(function (window) {
  'use strict';

  const tableSelector = '.table';
  const tables = document.querySelectorAll(tableSelector);
  const collapsibleTableClass = 'collapsible-table';
  const collapsibleTableActiveClass = 'js-collapsible-table--active';
  const collapsibleTableToggleSelector = '.js-table-toggle-control';
  const storeHoursTableClass = 'table--store-hours';
  const storeHoursTodayClass = 'js-store-hours-table--today';
  const today = new Date;
  const weekday = today.getDay();

  function toggleCollapsibleTable(e) {
    e.target.closest(tableSelector).classList.toggle(collapsibleTableActiveClass);
    e.preventDefault();
  }

  function init() {
    if (tables) {
      for (let i = 0; i < tables.length; i++) {
        const table = tables[i];

        // Handle collapsible tables.
        if (table.classList.contains(collapsibleTableClass)) {
          const toggleControl = table.querySelector(collapsibleTableToggleSelector);
          toggleControl.addEventListener('click', toggleCollapsibleTable);
        }

        // Handle store hours tables.
        if (table.classList.contains(storeHoursTableClass)) {
          const weekStartDay = table.getAttribute('data-week-start-day');
          // Javascript considers weeks to start on Sunday, so Sunday == 0. Our
          // tables may NOT start on Sunday, so we need to account for that (but
          // we assume that if they don't start on Sunday, they start on Monday!)
          //
          // Note that we're also compensating here for the fact that the weekday
          // value is zero-based while the nth-child selector we use to mark the
          // current day's row is one-based.
          const todaysHoursRowIndex = (weekStartDay > 0) ? weekday : weekday + 1;
          const todaysHoursRow = table.querySelector('tr:nth-child(' + todaysHoursRowIndex + ')');

          todaysHoursRow.classList.add(storeHoursTodayClass);
        }
      }
    }
  }

  init();

})(this);
